module.exports = __webpack_public_path__ + "static/img/02.e8b57e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/events/180119/02.png
// module id = cvnw
// module chunks = 0